import { Globe, MessageCircle, Phone, Search } from "lucide-react";
import { SearchSelect } from "../SearchSelect";

// Design: components/ai-agents/AgentCommon.tsx

export const channelIcon = (channel) => (channel === "Web widget" ? Globe : channel === "Voice call" || channel === "Web voice" ? Phone : MessageCircle);

export function PageHeading({ title, subtitle, action }) {
  return <header className="flex flex-wrap items-end justify-between gap-5"><div><p className="mb-1 text-small text-muted">AI Agents</p><h1 className="text-h1">{title}</h1><p className="mt-1 text-small text-muted">{subtitle}</p></div>{action}</header>;
}

export function SunButton({ children, onClick, disabled = false }) {
  return <button type="button" onClick={onClick} disabled={disabled} className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-sun px-5 text-small font-semibold text-ink hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-50">{children}</button>;
}

export function QuietButton({ children, onClick, disabled = false }) {
  return <button type="button" onClick={onClick} disabled={disabled} className="inline-flex h-10 items-center justify-center gap-2 rounded-full px-4 text-small font-semibold text-muted hover:bg-mist hover:text-ink disabled:opacity-50">{children}</button>;
}

export function StatusTag({ status }) {
  const style = status === "Live" || status === "Ready" ? "bg-success-soft text-success" : status === "Failed" ? "bg-danger-soft text-danger" : status === "Processing" || status === "Queued" ? "bg-sky-soft text-ink" : "bg-mist text-muted";
  return <span className={`inline-flex w-fit items-center rounded-full px-2.5 py-1 text-caption font-semibold ${style}`}>{status}</span>;
}

export function ChannelTag({ channel }) {
  const Icon = channelIcon(channel);
  return <span className="inline-flex items-center gap-1.5 rounded-full bg-mist px-2.5 py-1 text-caption text-ink"><Icon size={13} strokeWidth={1.75} />{channel}</span>;
}

export function Field({ label, hint, children, className = "" }) {
  return <label className={`flex min-w-0 flex-col gap-1.5 text-small font-medium ${className}`}><span>{label}</span>{children}{hint && <span className="text-caption font-normal text-muted">{hint}</span>}</label>;
}

export const inputClass = "h-11 w-full rounded-sm border border-line bg-paper px-3.5 text-small text-ink outline-none placeholder:text-muted/70 focus:border-ink focus:ring-2 focus:ring-ink/10";

export function SearchInput({ value, onChange, placeholder }) {
  return <label className="flex h-11 min-w-0 items-center gap-2 rounded-full bg-paper px-4 ring-1 ring-line focus-within:ring-ink/30"><Search size={16} strokeWidth={1.75} className="shrink-0 text-muted" /><input value={value} onChange={(event) => onChange(event.target.value)} aria-label={placeholder} placeholder={placeholder} className="min-w-0 flex-1 bg-transparent text-small outline-none placeholder:text-muted" /></label>;
}

/** Options: strings or { value, label }. */
export function SearchField({ label, value, options, onChange, placeholder, hint, disabled }) {
  return <Field label={label} hint={hint}><SearchSelect value={value} options={options} onChange={onChange} placeholder={placeholder ?? `Choose ${label.toLowerCase()}`} searchable disabled={disabled} /></Field>;
}
